var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.445,
    height: 23.364,
    viewBox: "0 0 23.445 23.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ec6321;stroke:#ec6321;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.6,25.238l-6.218-6.277a8.862,8.862,0,1,0-1.345,1.362L25.21,26.56a.957.957,0,0,0,1.351.035A.963.963,0,0,0,26.6,25.238ZM13.414,20.4a7,7,0,1,1,4.949-2.049A6.954,6.954,0,0,1,13.414,20.4Z",
    transform: "translate(-4 -3.993)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/search icon.26ee9a20dd035c81c8729810570cf2d1.svg";
export { ForwardRef as ReactComponent };